import { USState, TaxMapsSearchResult, GetDriversResult } from './models';
import { Nullable } from 'common';

export const GET_TAX_MAPS_STATES_SUCCESS = 'GET_TAX_MAPS_STATES_SUCCESS';
export const SET_TAX_MAPS_LOADING = 'SET_TAX_MAPS_LOADING';
export const GET_TAX_MAPS_DRIVERS_SUCCESS = 'GET_TAX_MAPS_DRIVERS_SUCCESS';
export const RESET_DRIVERS_DATA = 'RESET_DRIVERS_DATA';
export const RESET_RESULTS = 'RESET_RESULTS';
export const TAX_MAPS_RESULT_SUCCESS = 'TAX_MAPS_RESULT_SUCCESS';

export interface TaxMapsState {
  loading: boolean;
  usState: Nullable<USState>;
  result: Nullable<TaxMapsSearchResult>;
  driversData: Nullable<GetDriversResult>;
}

export interface SetResultLoadingType {
  type: typeof SET_TAX_MAPS_LOADING;
  loading: boolean;
}

/* GET_STATES */

export interface GetStateSuccessType {
  type: typeof GET_TAX_MAPS_STATES_SUCCESS;
  usState: USState;
}

/* GET_DRIVERS */

export interface GetDriversSuccessType {
  type: typeof GET_TAX_MAPS_DRIVERS_SUCCESS;
  driversData: GetDriversResult;
}

export interface TaxMapsSearchResultSuccessType {
  type: typeof TAX_MAPS_RESULT_SUCCESS;
  result: TaxMapsSearchResult;
}

export interface ResetDriversDataType {
  type: typeof RESET_DRIVERS_DATA;
}

export interface ResetResultsType {
  type: typeof RESET_RESULTS;
}

export type TaxMapsTypes =
  | GetStateSuccessType
  | SetResultLoadingType
  | GetDriversSuccessType
  | TaxMapsSearchResultSuccessType
  | ResetDriversDataType
  | ResetResultsType;
